import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIIntersectionObserver from 'UIComponents/observer/UIIntersectionObserver';
import useCampaignToAutoSelectPopover from '../hooks/useCampaignToAutoSelectPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CampaignToAutoSelectPopover(_ref) {
  let {
      children
    } = _ref,
    hookParams = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isPopoverOpen,
    onYes,
    onNo
  } = useCampaignToAutoSelectPopover(hookParams);
  return /*#__PURE__*/_jsx(UIIntersectionObserver, {
    renderContent: isIntersecting => /*#__PURE__*/_jsx(UIPopover, {
      open: isIntersecting && isPopoverOpen,
      width: 320,
      content: {
        body: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "campaignSelect.campaignAutoSelectPopover.text"
        }),
        footer: /*#__PURE__*/_jsxs(UIButtonWrapper, {
          children: [/*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            onClick: onYes,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaignSelect.campaignAutoSelectPopover.buttonYes"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            use: "tertiary-light",
            onClick: onNo,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "campaignSelect.campaignAutoSelectPopover.buttonNo"
            })
          })]
        })
      },
      children: children
    })
  });
}